export default __webpack_public_path__ + "src/_images/ls_favicon.png";